import React from 'react';
import { useTranslation } from '@shared/core';
import { LinkV2 } from '@withjoy/joykit';

export const PrivacyNoticeLink = () => {
  const { t } = useTranslation('createWedding');

  return (
    <LinkV2
      typographyVariant="label1"
      isExternal
      href="https://privacy.withjoy.com/privacy-policy#california-privacy-notice"
      fontSize="inherit"
      color="gray8"
    >
      {t('createAccount', 'privacyNotice')()}
    </LinkV2>
  );
};
